export enum TimeLineType {
    Note = 0,
    Email = 1,
    Event = 2,
}
